import { render } from "./home.vue?vue&type=template&id=49605fb1&scoped=true&style=position%3Arelative"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=49605fb1&lang=less&scoped=true"

import exportComponent from "D:\\work\\web\\sal_appgd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49605fb1"]])

export default __exports__